(() => {
  const initGalleryProgress = (root = document) => {
    root.querySelectorAll('[id^="MainProduct-"] media-gallery').forEach((gallery) => {
      if (gallery.id.endsWith('-duplicate') || gallery.dataset.albaProgress === 'ready') return;

      const slider = gallery.querySelector('.product__media-list.slider--mobile');
      const controls = gallery.querySelector('.slider-buttons');
      if (!slider || !controls) return;

      gallery.dataset.albaProgress = 'ready';

      const progress = document.createElement('div');
      progress.className = 'alba-gallery-progress';
      progress.setAttribute('aria-hidden', 'true');
      progress.innerHTML = '<span class="alba-gallery-progress__bar"></span>';
      controls.before(progress);

      let frame;
      const visibleSlides = () => Array.from(slider.querySelectorAll('.product__media-item:not(.hidden)'));

      const update = () => {
        frame = undefined;
        const slides = visibleSlides();
        if (!slides.length) return;

        const current = slides.reduce((closest, slide, index) => {
          const distance = Math.abs(slide.offsetLeft - slider.scrollLeft);
          return distance < closest.distance ? { index, distance } : closest;
        }, { index: 0, distance: Number.POSITIVE_INFINITY }).index;

        progress.style.setProperty('--alba-gallery-count', slides.length);
        progress.style.setProperty('--alba-gallery-index', current);
      };

      const requestUpdate = () => {
        if (frame) return;
        frame = requestAnimationFrame(update);
      };

      slider.addEventListener('scroll', requestUpdate, { passive: true });
      window.addEventListener('resize', requestUpdate, { passive: true });

      new MutationObserver(requestUpdate).observe(slider, {
        subtree: true,
        attributes: true,
        attributeFilter: ['class'],
      });

      update();
    });
  };

  const initProduct = (root = document) => {
    initGalleryProgress(root);

    root.querySelectorAll('.main-product__info-container').forEach((productInfo) => {
      if (productInfo.dataset.albaProductV2 === 'ready') return;
      productInfo.dataset.albaProductV2 = 'ready';

      productInfo.querySelectorAll('.alba-option--colour').forEach((option) => {
        const selectedLabel = option.querySelector('.alba-option-label__selected');
        if (!selectedLabel) return;

        const syncLabel = () => {
          const checked = option.querySelector('input[type="radio"]:checked');
          if (checked) selectedLabel.textContent = checked.value.toUpperCase();
        };

        option.addEventListener('change', syncLabel);
        syncLabel();
      });

      const saleMessage = productInfo.querySelector('[data-alba-sale-message]');
      const variantPicker = productInfo.querySelector('variant-selects');
      if (saleMessage) {
        let variants = [];
        try {
          variants = JSON.parse(variantPicker?.querySelector('script[type="application/json"]')?.textContent || '[]');
        } catch (_) {
          variants = [];
        }

        const selectedVariant = () => {
          const idInput = productInfo.querySelector('form input[name="id"], input.product-variant-id');
          const selectedId = idInput?.value;
          if (selectedId) {
            const byId = variants.find((variant) => String(variant.id) === String(selectedId));
            if (byId) return byId;
          }

          const selectedOptions = [...productInfo.querySelectorAll('variant-selects .product-form__input')]
            .map((option) => option.querySelector('input[type="radio"]:checked, select')?.value)
            .filter(Boolean);
          return variants.find((variant) => variant.options?.every((value, index) => value === selectedOptions[index]));
        };

        const syncSaleMessage = () => {
          const variant = selectedVariant();
          if (!variant) return;
          const price = Number(variant.price || 0);
          const compareAt = Number(variant.compare_at_price || 0);
          saleMessage.hidden = !(compareAt > price);
        };

        variantPicker?.addEventListener('change', () => {
          requestAnimationFrame(() => requestAnimationFrame(syncSaleMessage));
        });
        syncSaleMessage();
      }

      productInfo.querySelectorAll('.alba-size-guide-trigger').forEach((trigger) => {
        trigger.addEventListener('click', () => {
          const nativeTrigger = productInfo.querySelector('.sizing-chart__button');
          if (nativeTrigger) nativeTrigger.click();
        });
      });
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initProduct());
  } else {
    initProduct();
  }

  document.addEventListener('shopify:section:load', (event) => initProduct(event.target));

  document.addEventListener('click', (event) => {
    const recommendationTab = event.target.closest('[data-alba-recommendation-tab]');
    if (recommendationTab) {
      const recommendations = recommendationTab.closest('.alba-recommendations');
      const selectedTab = recommendationTab.dataset.albaRecommendationTab;

      recommendations.querySelectorAll('[data-alba-recommendation-tab]').forEach((tab) => {
        const isSelected = tab === recommendationTab;
        tab.setAttribute('aria-selected', String(isSelected));
        tab.tabIndex = isSelected ? 0 : -1;
      });
      recommendations.querySelectorAll('[data-alba-recommendation-panel]').forEach((panel) => {
        panel.hidden = panel.dataset.albaRecommendationPanel !== selectedTab;
      });
      return;
    }

    const videoButton = event.target.closest('[data-alba-video-toggle]');
    if (!videoButton) return;
    const video = videoButton.querySelector('video');
    if (!video) return;

    if (video.paused) {
      document.querySelectorAll('[data-alba-video-toggle][data-playing="true"] video').forEach((playingVideo) => {
        if (playingVideo === video) return;
        playingVideo.pause();
        playingVideo.closest('[data-alba-video-toggle]').dataset.playing = 'false';
      });
      video.play().then(() => { videoButton.dataset.playing = 'true'; }).catch(() => {});
    } else {
      video.pause();
      videoButton.dataset.playing = 'false';
    }
  });

  document.addEventListener('keydown', (event) => {
    const recommendationTab = event.target.closest('[data-alba-recommendation-tab]');
    if (!recommendationTab || !['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;

    const tabs = [...recommendationTab.closest('[role="tablist"]').querySelectorAll('[data-alba-recommendation-tab]')];
    const currentIndex = tabs.indexOf(recommendationTab);
    let nextIndex = currentIndex;
    if (event.key === 'ArrowLeft') nextIndex = (currentIndex - 1 + tabs.length) % tabs.length;
    if (event.key === 'ArrowRight') nextIndex = (currentIndex + 1) % tabs.length;
    if (event.key === 'Home') nextIndex = 0;
    if (event.key === 'End') nextIndex = tabs.length - 1;
    event.preventDefault();
    tabs[nextIndex].focus();
    tabs[nextIndex].click();
  });
})();
